export default __webpack_public_path__ + "static/media/wizard_cap.e4fb4287.svg";